import { ReactElement } from 'react'
import { Navigate, useParams } from 'react-router'

import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'
import { getOnboardingStepFlow } from '../../../../constants/onboardingStepFlow'
import { onboardingPathToStep, onboardingStepToPath } from '../../../../constants/onboardingStepPathMapping'
import { OnboardingFormContextProvider } from '../../../../contexts/OnboardingFormContext'
import { useOnboardingSetupContext } from '../../../../contexts/OnboardingSetupContext'
import { OnboardingStep } from '../../../../enums/onboardingStep'
import { OnboardingLayout } from '../OnboardingLayout'
import { getStepComponentMapFromPath } from './utils/getStepComponentMapFromPath'

export const StepRouter = (): ReactElement | null => {
  const { step } = useParams<{ step: OnboardingStep }>()
  const { url: baseUrl } = useOrganizationViewUrl(reactRoute.organization.onboarding.getMainRoute())
  const { firstStep, isExtendedQuestionnaire, isFetched } = useOnboardingSetupContext()

  const onboardingStepComponent = step ? getStepComponentMapFromPath()[step] : undefined
  const setupStep = step ? onboardingPathToStep[step] : undefined
  const isStepInCurrentFlow = Boolean(setupStep && getOnboardingStepFlow(isExtendedQuestionnaire)[setupStep])

  if (!isFetched || !firstStep) {
    return null
  }

  const firstStepUrl = `${baseUrl}/${onboardingStepToPath[firstStep]}`

  if (!step || !onboardingStepComponent || !isStepInCurrentFlow) {
    return <Navigate to={firstStepUrl} replace />
  }

  return (
    <OnboardingFormContextProvider step={step}>
      <OnboardingLayout>{onboardingStepComponent}</OnboardingLayout>
    </OnboardingFormContextProvider>
  )
}
